import React from 'react';
import { Button } from '../../basic-ui-components/button/base/button.component';
import {ButtonsWrapperDefaultBox} from './boxes/actions/buttons-wrapper.box';
import {ButtonWrapperDefaultBox, ButtonSpacerDefaultBox} from './boxes/actions/button-wrapper.box';
import {LinkActionBox} from './boxes/actions/link-action.box';
import {LinkWrapperDefaultBox} from './boxes/actions/link-wrapper.box';
import classNames from "classnames";
import {CyClass} from "../../../common/cy-classes";


export interface IModalDialogActionProps {
    text: string;
    onClick(): void;
    className?: string;
    disabled?:boolean;
}
export interface IModalDialogButtonsComponentProps {
    buttonsOnSeparateLines?: boolean;
    primaryAction: IModalDialogActionProps;
    secondaryAction?: IModalDialogActionProps & {useWarningPreset?: boolean};
    linkAction?: IModalDialogActionProps;
    className?: string;
}

export class ModalDialogActionsComponent extends React.Component<IModalDialogButtonsComponentProps> {
    render() {
        return <>
            <ButtonsWrapperDefaultBox buttonsOnSeparateLines={this.props.buttonsOnSeparateLines} className={classNames(this.props.className, CyClass('cy-modal-dialog-buttons-area'))}>
                <ButtonWrapperDefaultBox buttonsOnSeparateLines={this.props.buttonsOnSeparateLines}>
                    <Button
                        onClick={this.props.primaryAction.onClick}
                        disabled = {this.props.primaryAction.disabled}
                        preset="secondary"
                        fullWidth={true}
                        className={this.props.primaryAction.className}
                    >
                        {this.props.primaryAction.text}
                    </Button>
                </ButtonWrapperDefaultBox>
                {this.props.secondaryAction ? <><ButtonSpacerDefaultBox /><ButtonWrapperDefaultBox  buttonsOnSeparateLines={this.props.buttonsOnSeparateLines}>
                    <Button
                        onClick={this.props.secondaryAction.onClick}
                        disabled = {this.props.secondaryAction.disabled}
                        preset={this.props.secondaryAction.useWarningPreset ? "warning" : "flatStroked"}
                        fullWidth={true}
                        className={this.props.secondaryAction.className}
                    >
                        {this.props.secondaryAction.text}
                    </Button>
                </ButtonWrapperDefaultBox></> : null}
            </ButtonsWrapperDefaultBox>
            {this.props.linkAction ? <LinkWrapperDefaultBox>
                <LinkActionBox
                    onClick={this.props.linkAction.onClick}
                    disabled = {this.props.linkAction.disabled}
                    className={this.props.linkAction.className}
                >{this.props.linkAction.text}</LinkActionBox>
            </LinkWrapperDefaultBox> : null}
        </>;
    }
}
